import { FieldWrapper } from '@fukuri-admins/ui/common/Form/FieldWrapper';
import { extractErrorMessages } from '@fukuri-admins/ui/common/Form/logics/extractErrorMessages';
import { useController, useFormContext } from 'react-hook-form';
import styles from './styles.module.scss';

type Props = {
  name: string;
  label?: string;
  accept?: string;
  selectedFile?: File;
  displayFileName?: string;
  hasFile?: boolean;
  onFileChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onRemoveFile: () => void;
};

export const FileInputFieldController: React.FC<Props> = ({
  name,
  label = 'ファイル',
  accept = 'application/pdf',
  selectedFile,
  displayFileName,
  hasFile,
  onFileChange,
  onRemoveFile,
}) => {
  const { control } = useFormContext();
  const {
    fieldState: { error },
  } = useController({ control, name });

  const showFile = hasFile !== undefined ? hasFile : !!selectedFile;
  const fileName = displayFileName || selectedFile?.name;
  const hasError = !!error;

  return (
    <FieldWrapper htmlFor={name} labelText={label} errorMessages={extractErrorMessages(error)}>
      <div className={styles.fileInputWrapper}>
        <input
          type='file'
          id={name}
          className={styles.hiddenFileInput}
          accept={accept}
          onChange={onFileChange}
        />
        {!showFile ? (
          <label
            htmlFor={name}
            className={`${styles.fileInputLabel} ${hasError ? styles.error : ''}`}
          >
            <span className={styles.fileInputLabelText}>ファイル選択</span>
            <span className={styles.fileInputPlaceholder}>ファイルが選択されていません</span>
          </label>
        ) : (
          <div className={`${styles.fileSelectedContainer} ${hasError ? styles.error : ''}`}>
            <span className={styles.fileName}>{fileName}</span>
            <button type='button' onClick={onRemoveFile} className={styles.removeButton}>
              ×
            </button>
          </div>
        )}
      </div>
    </FieldWrapper>
  );
};
